import { Box } from 'react-scale/components/pages/homepage/build-ai/box';
import { RLHF } from 'react-scale/components/pages/homepage/build-ai/tabs/content/rlhf';
import CTA from 'react-scale/components/elements/cta';

export const BoxRLHF = () => {
  return (
    <Box
      title="RLHF"
      subtitle="Powering the next generation of Generative AI."
      inverted
      imageHTML={<RLHF />}
    >
      <p className="mt-6 mb-8 text-sm md:text-base text-black sm:text-white">
        Scale Generative AI Data Engine powers the most advanced LLMs and generative models in the
        world through world-class RLHF, data generation, model evaluation, safety,
        and&nbsp;alignment.
      </p>
      {/* @ts-ignore: Unreachable code error */}
      <CTA
        cta={{
          buttons: [
            {
              text: 'Learn More',
              href: '/rlhf',
              type: 'primary',
              variant: 'black-transparent'
            },
            {
              text: 'Label My Data',
              href: 'https://dashboard.scale.com/signup?product=rapid&redirect_url=%2Frapid',
              type: 'secondary'
            }
          ]
        }}
      />
    </Box>
  );
};
